import { render, staticRenderFns } from "./NearDeathExperience.vue?vue&type=template&id=a3d42c5a&scoped=true&lang=pug&"
import script from "./NearDeathExperience.vue?vue&type=script&lang=js&"
export * from "./NearDeathExperience.vue?vue&type=script&lang=js&"
import style0 from "./NearDeathExperience.vue?vue&type=style&index=0&id=a3d42c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d42c5a",
  null
  
)

export default component.exports